import { SpotData, TideWindData } from "../datastructures";
import {
  getTideCurrentInfo,
  relativeDateName,
  roundPlaces,
  convertWind,
} from "../util/util";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import React from "react";

export interface TideMarkerProps {
  tideWindData: TideWindData[];
  etimeToShow: number;
  nowTimestampSecs: number;
  spot: SpotData;
  windUnits: string;
}

export const TideMarker: React.FC<TideMarkerProps> = ({
  tideWindData,
  etimeToShow,
  nowTimestampSecs,
  spot,
  windUnits,
}) => {
  // Find tideWindData for this spot and validtime

  // Use the shared utility for all tide info
  const tideInfo = getTideCurrentInfo(tideWindData, etimeToShow, spot.id);
  const smiley = tideInfo?.smiley;
  const upSpeedMsec = tideInfo?.upSpeedMsec ?? 0;
  const currColor = tideInfo?.currColor ?? undefined;
  const currDir = tideInfo?.currDir ?? "";
  const waterLevel = tideInfo?.waterLevel;
  const markerHtml = `<div style="font-size:1.6em;text-align:center;line-height:1.2;background:transparent;border:none;box-shadow:none;padding:0;"><div style='font-size:1.2em;'>${
    smiley ?? ""
  }</div></div>`;
  const tideIcon = new L.DivIcon({
    className: "tide-marker-icon-info",
    html: markerHtml,
    iconSize: [60, 48],
    iconAnchor: [30, 24],
  });
  return (
    <Marker
      position={{ lat: spot.kf_actual_n, lng: spot.kf_actual_e }}
      icon={tideIcon}
    >
      <Popup>
        <b>
          <a
            href={`/spotinfo?spot=${spot.id}&day=${relativeDateName(
              etimeToShow === 0 ? nowTimestampSecs : etimeToShow,
            )}`}
            rel="noopener noreferrer"
            style={{ color: "inherit", textDecoration: "underline" }}
          >
            {spot.name}
          </a>
        </b>
        <br />
        <span
          style={{
            fontWeight: "bold",
            color: currColor,
            whiteSpace: "nowrap",
            display: "inline-block",
          }}
        >
          {upSpeedMsec ? Math.abs(convertWind(upSpeedMsec, windUnits, 2)) : "-"}{" "}
          {windUnits} {smiley ?? ""}
          {upSpeedMsec !== 0 && (
            <span style={{ color: currColor, marginLeft: 6 }}>{currDir}</span>
          )}
        </span>
        <br />
        Waterstand:{" "}
        {waterLevel !== undefined ? roundPlaces(waterLevel, 2) + " m" : "-"}
      </Popup>
    </Marker>
  );
};
